/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_Q4Inputs */

const en_fc_home_faq_q4 = /** @type {(inputs: Fc_Home_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can it open my Premiere Pro projects?`)
};

/**
* | output |
* | --- |
* | "Can it open my Premiere Pro projects?" |
*
* @param {Fc_Home_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_q4 = /** @type {((inputs?: Fc_Home_Faq_Q4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_Q4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_q4(inputs)
});
export { fc_home_faq_q4 as "fc.home.faq.q4" }